import { Input, Radio } from 'antd'
import CustomSelect from 'base/ui/components/CustomSelect'
import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { RoutingModel } from 'services/routing_services'
import { routingPresenter, routingStore } from 'stores/root_store'
type props = {
  setValueDes: (value: string) => void
  valueDes: string,
  stepCodeValue: string,
  setStepCodeValue: (value: string) => void,
  radioCheck: string,
  setRadioCheck: (value: string) => void
  modalOpen?: boolean

}
const ModalCreateDes = ({ setValueDes, valueDes, stepCodeValue, setStepCodeValue, radioCheck, setRadioCheck, modalOpen }: props) => {

  // List dropdown routing
  const [listRouting, setListRouting] = useState<RoutingModel[]>([]);

  // Call api get list routing
  const getDropDownRouting = async (keyWord: string) => {
    await routingPresenter.getListRouting(routingStore, keyWord);
    setListRouting(routingStore.routing.data);
  };

  const searchRouting = useCallback(debounce(getDropDownRouting, 300), [])

  useEffect(() => {

    getDropDownRouting('PLMAU');
    setStepCodeValue('PLMAU');
  }, [modalOpen, radioCheck])


  return (
    <div className='mt-6'>
      <div className='flex gap-2 items-center justify-center mb-5'>
        <div className='font-bold w-[120px]'>Loại lệnh sản xuất</div>
        <Radio.Group
          className="flex-1"
          onChange={(e) => setRadioCheck(e.target.value)}
          value={radioCheck}
        >
          <Radio value={'VS'}>Vệ sinh</Radio>
          <Radio value={'LK'}>Khác</Radio>
        </Radio.Group>
      </div>
      <div
        style={{
          display: radioCheck === 'VS' ? 'none' : 'flex'
        }}
        className="w-full flex mb-5">
        <CustomSelect
          classNameLabel='!min-w-[108px] mt-1 !text-left'
          className='!flex-1 w-full'
          isRequired
          title="Công đoạn"
          data={listRouting}
          fieldNames={{ label: 'stepName', value: 'stepCode' }}
          onChangeValue={(value: string) => setStepCodeValue(value)}
          idKey="stepCode"
          showSearch
          value={stepCodeValue}
          optionFilterProp="children"
          filterOption={false}
          onClear={() => {
            getDropDownRouting('');
          }}
          onSearch={(value) => searchRouting(value)}
          allowClear
          placeholder="--Tất cả--"
        />
      </div>
      {/* </div> */}
      <div className='flex gap-2 items-center justify-center'>
        <div className='font-bold w-[120px]'>Ghi chú sản xuất <span className='text-red-500'>*</span></div>
        <Input className='flex-1' value={valueDes} onChange={e => setValueDes(e.target.value)} required />
      </div>
    </div>
  )
}

export default ModalCreateDes